<template>
  <MdiFontIcon
    name="loading"
    class="w-4 h-4 animate-spin"
  />
</template>
